import Model from "./Model";
import { $constants } from "../plugins/constants";

/**
 * Registro diário do Diário de Auxiliares (#7286).
 *
 * A situação replica o comportamento da aula no Diário Online, mas com nomenclatura
 * própria (atendimento, não aula): as cores vêm de $constants.situacoesAtendimentos.
 */
export default class AtendimentoAuxiliar extends Model {
  constructor(atendimento) {
    super();
    Object.assign(this, atendimento);
    this.descricaoSituacao = this.getDescricaoSituacao();
    this.color = this.getColor();
    this.bimestreDescricao = this.getBimestreDescricao();
  }

  getDescricaoSituacao() {
    if (!this.situacao) return "Aguardando confirmação";
    return this.situacao;
  }

  getColor() {
    const situacao = $constants.situacoesAtendimentos.find(
      (item) => item.descricao === this.descricaoSituacao
    );
    return situacao ? situacao.cor : "success";
  }

  getBimestreDescricao() {
    const bimestre = $constants.bimestres.find((item) => item.value === this.bimestre);
    return bimestre ? bimestre.desc : `Bimestre ${this.bimestre}`;
  }

  get descricaoHorario() {
    return this.horario ? this.horario.descricao : "- - -";
  }

  get nomeAluno() {
    return this.matricula && this.matricula.aluno ? this.matricula.aluno.nomecompleto : "- - -";
  }
}
